module.exports = __webpack_public_path__ + "img/apple-black.373d213b.svg";